import React from 'react';
import RichTextEditor from 'components/rich_text_editor/RichTextEditor';

interface Props {
    chartId: number | null;
    HTMLValue: string;
    onChange: (HTMLDump: string) => void;
}

const ChartCommentRichTextEditor = React.memo<Props>((
    {
        chartId = null,
        HTMLValue,
        onChange,
    },
) => {
    const handleChange = (htmlContent: string) => {
        onChange(htmlContent);
    };

    return (
        <RichTextEditor
            value={HTMLValue}
            onChange={handleChange}
        />
    );
});

export default ChartCommentRichTextEditor;